import React, { useState } from 'react';
import propTypes from 'prop-types';
;;
import { Button, Columns, Column, ModalCardBody, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Control, Field as BulmaField } from 'src/ui/mui-ui-kit';;
import { Form, Field } from 'react-final-form';
import { usePoseWithBulma } from 'src/ui/hooks';
import {
  FadeInDiv,
  AnimatedCard,
  UiInputAdapter,
  UiDatePickerAdapter,
  InnerLoader,
} from 'src/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { composeValidators, required } from 'src/ui/validations';

export function SarModal({ open, sar, onClose, addSar }) {
  const [loading, setLoading] = useState(false);
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(open);
  const label = sar ? 'Edit' : 'Add';

  async function finish(values) {
    setLoading(true);

    const result = await addSar(values);

    setLoading(false);

    return result;
  }

  return (
    <Form
      // eslint-disable-next-line react/jsx-no-bind
      onSubmit={finish}
      initialValues={sar}
      render={({ handleSubmit, hasValidationErrors }) => (
        <Modal isActive={isModalVisible} className="badge-modal" tag="form">
          <ModalBackground
            tag={FadeInDiv}
            pose={currentPose}
            onPoseComplete={onPoseComplete}
          />
          <ModalCard tag={AnimatedCard} pose={currentPose}>
            <InnerLoader visible={loading} />
            <ModalCardHeader>
              <ModalCardTitle
                tag="h5"
                className="has-text-weight-semibold columns is-vcentered"
              >
                <Column isSize="narrow" tag="span">
                  <span className="icon is-medium has-icon-gradient-bright">
                    <FontAwesomeIcon icon={['fas', 'id-badge']} size="lg" />
                  </span>
                </Column>
                <Column tag="span" hasTextColor="primary" isPaddingless>
                  {label} A SAR
                </Column>
              </ModalCardTitle>
            </ModalCardHeader>
            <ModalCardBody>
              <Columns isMultiline>
                <Column isSize="1/2">
                  <Field
                    component={UiInputAdapter}
                    name="sarId"
                    id="sarId"
                    label="Fincen Id"
                    required
                    validate={composeValidators('Fincen Id', required)}
                  />
                </Column>
                <Column isSize="1/2">
                  <Field
                    component={UiInputAdapter}
                    name="sarFilerName"
                    id="sarFilerName"
                    label="Filed By"
                    required
                    validate={composeValidators('Filed By', required)}
                  />
                </Column>
                <Column isSize="1/2">
                  <Field
                    component={UiDatePickerAdapter}
                    name="sarFiledDate"
                    id="sarFiledDate"
                    label="Dated Filed"
                    required
                    withPortal
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                    validate={composeValidators('Date Filed', required)}
                  />
                </Column>
              </Columns>
              <BulmaField isGrouped="centered">
                <Control>
                  <Button hasTextColor="info" onClick={onClose}>
                    Cancel
                  </Button>
                </Control>
                <Control>
                  <Button
                    isColor="gradient-bright"
                    disabled={loading || hasValidationErrors}
                    onClick={handleSubmit}
                  >
                    Save SAR
                  </Button>
                </Control>
              </BulmaField>
            </ModalCardBody>
          </ModalCard>
        </Modal>
      )}
    />
  );
}

SarModal.defaultProps = {
  sar: null,
};

SarModal.propTypes = {
  open: propTypes.bool.isRequired,
  onClose: propTypes.func.isRequired,
  sar: propTypes.object,
  addSar: propTypes.func.isRequired,
};
